import * as React from 'react';
import { cn } from './utils';
import { Button } from './button';

function EmptyState({
  icon: Icon,
  illustration,
  title,
  description,
  action,
  actionLabel,
  onAction,
  className,
  children
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-6 py-12 text-center animate-in fade-in duration-300',
        className
      )}
    >
      {illustration ? (
        <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-2xl bg-muted/60">
          {illustration}
        </div>
      ) : Icon ? (
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/8">
          <Icon className="h-8 w-8 text-primary" aria-hidden />
        </div>
      ) : null}

      <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      {description && (
        <div className="mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</div>
      )}

      {children}

      {actionLabel && onAction && (
        <Button type="button" onClick={onAction} className="mt-6" size="lg">
          {actionLabel}
        </Button>
      )}

      {action}
    </div>
  );
}

export { EmptyState };
